











































import { SfButton, SfLoader } from "@storefront-ui/vue";
import {
    defineComponent,
    ref,
    onMounted,
    onBeforeUnmount,
    computed,
} from "@nuxtjs/composition-api";
import { useSearch } from "composables/useSearch";
import ProductCardHorizontal from "components/catalog/Product/ProductCardHorizontal.vue";
import { lock, clearBodyLocks } from "tua-body-scroll-lock";
import { useCart } from "@wemade-vsf/customer";
import useDeliverySwatchData from "~/composables/useDeliverySwatchData";

export default defineComponent({
    name: "SearchResults",
    components: {
        ProductCardHorizontal,
        CheckboxType: () =>
            import(
                "components/catalog/Category/Filters/Renderer/CheckboxType.vue"
            ),
        SwatchType: () =>
            import(
                "components/catalog/Category/Filters/Renderer/SwatchType.vue"
            ),
        RadioType: () =>
            import(
                "components/catalog/Category/Filters/Renderer/RadioType.vue"
            ),
        YesNoType: () =>
            import(
                "components/catalog/Category/Filters/Renderer/YesNoType.vue"
            ),
        RangeType: () =>
            import(
                "components/catalog/Category/Filters/Renderer/RangeType.vue"
            ),
        SfButton,
        SfLoader,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        columns: {
            type: [Number, String],
            default: 3,
        },
    },
    setup() {

        const { searchResults, loading, closeSearch, term } = useSearch();
        const searchContainer = ref(null);

        onBeforeUnmount(() => {
            if (!process.server && searchContainer.value) clearBodyLocks();
        });

        const productsLeft = computed(() => {
            if (
                !searchResults.value?.total_count ||
                !searchResults.value.page_info?.page_size ||
                !searchResults.value.page_info?.current_page
            )
                return 0;
            const leftProducts =
                searchResults.value.total_count -
                searchResults.value.page_info.current_page *
                    searchResults.value.page_info.page_size;
            return leftProducts > 0 ? leftProducts : 0;
        });

        const { cart, load: loadCart } = useCart();
        const { load: loadSwatchData, deliverySwatchData } =
            useDeliverySwatchData();

        if (!deliverySwatchData.value) {
            loadSwatchData();
        }

        onMounted(async () => {
            if (!process.server && searchContainer.value) {
                lock(searchContainer.value);
            }

            if (!cart.value || !cart.value.id) {
                await loadCart();
            }
        });

        return {
            searchResults,
            searchContainer,
            closeSearch,
            productsLeft,
            loading,
            cart,
            term,
            deliverySwatchData,
        };
    },
});
